<template>
  <div>
    <h1 class="show-in-mobile">Pedidos</h1>
    
    <div class="filter-container" style="margin-bottom:10px; text-align:left">
      <el-row>
        <el-col v-if="hasPermission('edit')" :xs="24" :sm="8" :md="6" :lg="6" :xl="4"  class="filter-col">

          <el-select
              size="mini"
              placeholder="Seleccione"
              style="width: 120px; margin-right:5px"
              v-model="selectionToChange"
            >
              <el-option
                v-for="item in [{label:'Asignar fecha', value:'assignDate'}, {label:'Realizado', value:'completed'}, {label: 'Cancelado', value: 'canceled'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-check"
            size="mini"
            @click="handleChangeState"
          >
            <span>Aplicar</span>
          </el-button>
        </el-col>
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4" class="filter-col">
          <span style="margin-left: 20px; margin-right: 10px; font-size: 14px;">Filtrar</span>
          <el-input
            v-model="search"
            size="mini"
            placeholder="Nombre o Razón Social"
            style="width: 150px; margin-right:5px"
          />
        </el-col>
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4" class="filter-col">
          <el-date-picker
            v-model="dateFilter"
            type="daterange"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
            range-separator="al"
            start-placeholder="Desde"
            end-placeholder="Hasta">
          </el-date-picker>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="4" class="filter-col">
          <el-button
            v-if="hasPermission('edit') && !is_mobile"
            class="filter-item"
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="handleDownload"
            :loading="loadingExportButton"
            style="margin-left:20px"
          >
            <span>Exportar</span>
          </el-button>

          <el-button
            v-if="hasPermission('edit')"
            class="filter-item"
            style="margin-left: 10px;"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleCreate"
          >
            <span>Nuevo pedido</span>
          </el-button>
        </el-col>
      </el-row>
    </div>

    <el-row v-if="is_mobile && ( current_user.role === 'superUser' || current_user.role === 'driver')">
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4" v-for="order in orderList.filter(data => {
        if( !dateFilter || (data.date >= dateFilter[0] && data.date <= dateFilter[1]))
          if(!search || data.full_name.toLowerCase().includes(searchInLowerCase) || data.business.toLowerCase().includes(searchInLowerCase) )
            return true
      })" :key="order.id" class="card-order">
          <el-card class="box-card" :name="order.id">
            <div slot="header" class="clearfix card-header">
              <el-checkbox v-if="current_user.role === 'superUser'" @change="changeCheck" v-model="orderSelecteds[order.id]" :true-label="`${order.id}-true`" :false-label="`${order.id}-false`" :label="order.business ? order.business : order.full_name" border size="mini"></el-checkbox>
              <label v-if="current_user.role === 'driver'" style="font-size: 14px; margin-left: 10px;">{{order.business ? order.business : order.full_name}}</label>
              <div style="float: right; margin-right: 10px;">
              <el-button size="mini" @click="handleEdit(order)" icon="el-icon-edit" />
              </div>
            </div>
            <div class="card-body">
              <div class="status">
                <el-tag
                  :type="order.status_class"
                  disable-transitions
                >{{order.status_label}}
                </el-tag>
                <span :class="order.date_class">{{order.date_text}}</span> {{order.date_hours}}
              </div>
              <div class="trash">
                {{order.count }} {{order.trash_unit_t}} de {{ order.trash_type_t}}
              </div>
              <div class="zone">
                <el-tag style="background: white; color: gray; border-color: #DCDFE6;">{{order.zone}}</el-tag>
                <div v-if="current_user.role === 'driver'">
                  <p>{{order.location}}</p>
                  <p>{{order.location_phone}}</p>
                  <div v-if="order.notes" style="border-top: 1px solid; border-color: #dedede;">
                    <p>{{order.notes}}</p>
                  </div>
                </div>
              </div>
              <div v-if="current_user.role === 'superUser'">
                Manifiesto 
                <i v-if="order.manifest" class="el-icon-success icon-green"></i>
                <i v-if="!order.manifest" class="el-icon-error icon-red"></i>
                <span style="padding-right:30px"></span>
                Pago 
                <i v-if="order.pay" class="el-icon-success icon-green"></i>
                <i v-if="!order.pay" class="el-icon-error icon-red"></i>
              </div>
            </div>
          </el-card>
        </el-col>
    </el-row>

    <el-table
      v-if="!is_mobile || (current_user.role != 'superUser' && current_user.role != 'driver')"
      v-loading="loading"
      element-loading-text="Cargando..."
      :data="orderList.filter(data => {
        if( !dateFilter || (data.date >= dateFilter[0] && data.date <= dateFilter[1]))
          if(!search || data.full_name.toLowerCase().includes(searchInLowerCase) || data.business.toLowerCase().includes(searchInLowerCase) )
            return true
      })"
      :summary-method="getSummaries"
      show-summary
      ref="orderListFiltered"
      :default-sort="{prop: 'date', order: 'descending'}"
      style="width: 100%"
      @row-dblclick="handleView"
      @selection-change="handleSelectionChange"
      @select = "handleSelectionRow"
      @select-all = "handleSelectAll"
    >
      <el-table-column
      v-if="isAdmin"
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column
        prop="status"
        label="Estado"
        width="130"
        :filters="status"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status_class"
            disable-transitions
            @click="handleEdit(scope.row)"
            style="cursor:pointer"
          >{{scope.row.status_label}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column 
        label="Residuo" 
        min-width="90"
        :filters="options"
        :filter-method="filterTrashType"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          {{scope.row.trash_type_t}}
        </template>
      </el-table-column>
      <el-table-column 
        label="Cantidad"
        :filters="units"
        :filter-method="filterUnits"
        filter-placement="bottom-end" 
        min-width="120">
        <template slot-scope="scope">
          {{scope.row.count}} {{scope.row.trash_unit_t}}
        </template>
      </el-table-column>
      <el-table-column
        label="Zona"
        min-width="130"
        :filters="zones"
        :filter-method="filterZone"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag>{{scope.row.zone}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Fecha" prop="date" sortable min-width="100">
        <template slot-scope="scope">
          <span :class="scope.row.date_class">{{scope.row.date_text}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Hora" prop="date_hours" sortable min-width="80"></el-table-column>
      <el-table-column 
        label="Man" 
        prop="manifest"  
        min-width="70"
        :filters="[{text:'Si', value: true}, {text:'No', value: false}]"
        :filter-method="filterMan">
        <template slot-scope="scope">
          <div @click="handleManifest(scope.row)" style="cursor:pointer;">
            <i v-if="scope.row.manifest" class="el-icon-success icon-green"></i>
            <i v-if="!scope.row.manifest" class="el-icon-error icon-red"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column 
        label="L" 
        prop="pay"  
        min-width="70"
        v-if="show != 'pending'"
        :filters="[{text:'Si', value: true}, {text:'No', value: false}]"
        :filter-method="filterPay">
        <template slot-scope="scope">
          <div @click="handlePay(scope.row)" style="cursor:pointer;">
            <i v-if="scope.row.pay" class="el-icon-success icon-green"></i>
            <i v-if="!scope.row.pay" class="el-icon-error icon-red"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column 
        label="Cert" 
        prop="certificate"  
        min-width="70"
        :filters="[{text:'Si', value: true}, {text:'No', value: false}]"
        :filter-method="filterCert">
        <template slot-scope="scope">
          <div @click="handleCertificate(scope.row)" style="cursor:pointer;">
            <i v-if="scope.row.certificate" class="el-icon-success icon-green"></i>
            <i v-if="!scope.row.certificate" class="el-icon-error icon-red"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Apellido y Nombre" prop="full_name" sortable min-width="180"></el-table-column>
      <el-table-column label="Razón Social" prop="business" min-width="280">
        <template slot-scope="scope">
          {{scope.row.business}}<br>
          {{scope.row.activity_t}}
        </template>
      </el-table-column>
      <el-table-column label="Retiro" prop="location" min-width="200"></el-table-column>
      <el-table-column label="Teléfono" prop="location_phone" min-width="100"></el-table-column>
      <el-table-column align="right" min-width="120">
        <template slot-scope="scope">
          <el-button v-if="hasPermission('edit')" size="mini" @click="handleEdit(scope.row)" icon="el-icon-edit" />
          <el-button
            v-if="hasPermission('all')"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>
    <!--
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[50, 100, 200, 400]"
      :page-size="100"
      layout="total, sizes, prev, pager, next"
      hide-on-single-page=true
      :total="400">
    </el-pagination>
    -->
    <!-- Modal Assign Date Form -->
    <el-dialog
      title="Asignar fecha"
      :visible.sync="dialogAssignDateVisible"
      width="600px"
      @close="handleDialogAssignDateClose"
    >
      <el-form :model="formAssignDate" ref="formAssignDate" :rules="rules" label-width="70px">
        <el-row>
          
          <el-col :xs="24" v-if="canEdit('date')">
            <el-form-item label="Fecha" prop="date">
              <el-date-picker
                v-model="formAssignDate.date"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                :default-value="defaultDate"
                placeholder="Seleccione una fecha"
                style="width:58%">
              </el-date-picker>
              <el-select
                v-model="formAssignDate.date_hours"
                placeholder="Seleccione"
                style="margin-left:10px; width:37%;"
              >
                <el-option label="Mañana" value="Mañana"></el-option>
                <el-option label="Tarde" value="Tarde"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAssignDateVisible = false" size="medium">Cancelar</el-button>
        <el-button
          :loading="loadingSaveButton"
          type="primary"
          @click="handleAssignDateSaveButton('formAssignDate')"
          size="medium"
        >Guardar</el-button>
    </span>
    </el-dialog>
    <!-- Modal Form -->
    <el-dialog
      :title="modal.name"
      :visible.sync="dialogFormVisible"
      width="60%"
      @close="handleDialogClose"
    >
      <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
        <el-row>
          
          <el-col :xs="24" :md="12">
            <el-form-item label="Generador" prop="full_name">
              <el-input v-if="modal.status != 'add'" v-model="form.full_name" readonly></el-input>
              <el-select
                v-if="modal.status == 'add'"
                v-model="form.client_id"
                placeholder="Seleccione"
                filterable
                :disabled="modal.readOnly"
                @change="handleChangeClient"
              >
                <el-option
                  v-for="client in clients"
                  :key="client.value"
                  :label="client.label"
                  :value="client.value"
                  :disabled="client.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="current_user.role == 'commercial' && modal.status == 'view'" :xs="24" :md="12">
            <el-form-item label="Razón Social" prop="business">
              <el-input v-model="form.business" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="current_user.role == 'commercial' && modal.status == 'view'" :xs="24" :md="12">
            <el-form-item label="CUIT" prop="cuit">
              <el-input v-model="form.cuit" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="current_user.role == 'commercial' && modal.status == 'view'" :xs="24" :md="12">
            <el-form-item label="Domicilio" prop="business_address">
              <el-input v-model="form.business_address" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" v-if="canEdit('location')">
            <el-form-item label="Retiro" prop="location">
              <el-input v-if="modal.status != 'add'" v-model="form.location" readonly></el-input>
              <el-select
                v-if="modal.status == 'add'"
                v-model="form.location_index"
                placeholder="Seleccione"
                @change="handleChangeLocation"
              >
                <el-option
                  v-for="location in locations"
                  :key="location.value"
                  :label="location.label + ' - ' + location.zone"
                  :value="location.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Residuos" prop="trash_type" style="text-align:left">
              <el-input v-if="modal.status != 'add'" v-model="form.trash_type_t" readonly></el-input>
              <el-select
                v-if="modal.status === 'add'" 
                v-model="form.trash_type"
                placeholder="Seleccione"
                filterable
                :disabled="modal.readOnly"
                @change="handleChangeTrashType"
              >
                <el-option
                  v-for="item in trash_types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="Cantidad" prop="count" class="count">
              <el-input-number v-model="form.count" @change="handleChangeCount" controls-position="right" :min="1" autocomplete="off" :disabled="modal.readOnly || !canEdit('count')" style="width:50%"></el-input-number>
              
              <el-input v-if="modal.status != 'add'" v-model="form.trash_unit_t" readonly style="margin-left:10px; width:47%"></el-input>
              <el-select
                v-if="modal.status == 'add'"
                v-model="form.trash_unit"
                placeholder="Seleccione"
                @change="handleChangeTrashUnit"
                style="margin-left:10px; width:47%;"
              >
                <el-option
                  v-for="unit in trash_units"
                  :key="unit.label"
                  :label="unit.label"
                  :value="unit.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="zoneMsg" v-if="canEdit('count')">
              <span v-if="minimun.count">El mínimo sugerido para esta zona es de {{minimun.count}} {{minimun.unit_t}}</span>
            </div>
          </el-col>
          <el-col :xs="24" :md="12" v-if="canEdit('status')">
            <el-form-item label="Estado" prop="status">
              <el-select
                v-model="form.status"
                placeholder="Seleccione"
                filterable
                :disabled="modal.readOnly || !canEdit('status')"
                @change="handleChangeStatus"
              >
                <el-option
                  v-for="state in status"
                  :key="state.value"
                  :label="state.label"
                  :value="state.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="10" v-if="canEdit('price') || current_user.role == 'commercial'">
            <el-form-item label="Precio ($)" prop="price">
              <el-input-number v-model="form.price" controls-position="right" autocomplete="off" :disabled="modal.readOnly || !canEdit('price')" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="4" :sm="2" v-if="canEdit('pay')">
            <el-form-item v-if="form.status === 'completed' || form.status === 'archived'" style="text-align:left" label-width="25px">
              <el-switch v-model="form.pay" :disabled="modal.readOnly || !canEdit('pay')"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="24" :lg="12" v-if="canEdit('date')">
            <el-form-item label="Fecha" prop="date" v-if="form.status && form.status != 'pending'">
              <el-date-picker
                v-model="form.date"
                type="date"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                :disabled="modal.readOnly || !canEdit('date')"
                :default-value="defaultDate"
                @change="handleChangeDate"
                placeholder="Seleccione una fecha"
                style="width:58%">
              </el-date-picker>
              <el-select
                v-model="form.date_hours"
                placeholder="Seleccione"
                :disabled="modal.status == 'view' || !canEdit('date_hours')"
                style="margin-left:10px; width:37%;"
              >
                <el-option label="Mañana" value="Mañana"></el-option>
                <el-option label="Tarde" value="Tarde"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="24" :lg="12" v-if="form.status && form.status != 'pending' && canEdit('date')" style="text-align:left; padding-left:30px; min-height: 65px !important; margin-bottom: 20px">
            <div v-loading="loadingTable" element-loading-text="Cargando...">
              <table v-if="form.status && form.status != 'pending' && form.date"  class="trash-quantity">
                <thead v-if="tableQuantity.length && !loadingTable">
                  <tr>
                    <td colspan="4" style="background:white">PEDIDOS PROGRAMADOS</td>
                  </tr>
                  <tr>
                    <th>Residuo</th>
                    <th>Unidad</th>
                    <th>Programado</th>
                    <th>Disponible</th>
                  </tr>
                </thead>
                <tr v-for="item in tableQuantity" :key="item.trash_type">
                  <td>{{item.trash_type_t}}</td>
                  <td>{{item.trash_unit_t}}</td>
                  <td>{{item.ordered}}</td>
                  <td :class="item.class">{{item.available}}</td>
                </tr>
                <tr v-if="!tableQuantity.length && !loadingTable">
                  <td colspan="4" style="height:33px">No hay pedidos programados para esta fecha</td>
                </tr>
              </table>
            </div>
          </el-col>
          <el-col :xs="24" :md="24" :lg="12" v-if="canEdit('manifest')">
            <el-form-item label="Nº Manifiesto" style="text-align:left">
              <el-input v-model="form.manifest" :readonly="modal.readOnly || !canEdit('manifest')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="24" :lg="12" v-if="canEdit('certificate')">
            <el-form-item label="Nº Certificado" style="text-align:left">
              <el-input v-model="form.certificate" :readonly="modal.readOnly || !canEdit('certificate')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="24" :lg="12">
            <el-form-item label="Notas">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                v-model="form.notes"
                :readonly="modal.readOnly || !canEdit('notes')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" v-if="canEdit('extraInfo')">
            <div class="extra-info">
              <span v-if="form.created_at">Agregado por: {{form.created_by}} el {{form.created_at}} hs.</span>
              <span v-if="form.updated_at"><br>Actualizado por: {{form.updated_by}} el {{form.updated_at}} hs.</span>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!modal.readOnly">
        <el-button @click="dialogFormVisible = false" size="medium">Cancelar</el-button>
        <el-button
          :loading="loadingSaveButton"
          type="primary"
          @click="handleSaveButton('form')"
          size="medium"
        >Guardar</el-button>
        <el-button
          v-if="current_user.role == 'driver'"
          :loading="loadingSaveButton"
          type="success"
          @click="handleSuccessButton('form')"
          size="medium"
        >Realizado</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cleanObject from '@/vendor/CleanObject'

export default {
  data() {
    var validateLocation = (rule, value, callback) => {
      if ( this.form.location_index === null ) {
        callback(new Error('Debe seleccionar una ubicación'));
      } else {
        callback();
      }
    };
    return {
      dateFilter: '',
      form: {
        client_id: '',
        full_name: '',
        status: '',
        date: '',
        date_hours: '',
        location_index: '',
        trash_type: '',
        trash_unit: '',
        count: '',
        price: '',
        created_at: '',
        created_by: '',
        updated_at: '',
        updated_by: '',
        certificate: '',
        manifest: '',
        notes: '',
        pay: false
      },
      locations: [],
      trash_types: [],
      trash_units: [],
      datePickerOptions: {
        disabledDate(time) {
          var d = new Date();
          d.setDate(d.getDate() - 1);
          // d = yesterday
          return time.getTime() < d;
        },
        /* cellClassName(time){

          if(time.getTime() < Date.now() - 8.64e6){
            return 'red';
          }
        } */
      },
      date: null,
      loading: false,
      loadingSaveButton: false,
      nameSaveButton: 'Guardar',
      loadingExportButton: false,
      search: "",
      dialogFormVisible: false,
      selectionToChange: 'assignDate',
      rules: {
        count: [
          {
            required: true,
            message: "Debe ingresar una cantidad",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "Debe ingresar un precio",
            trigger: "blur"
          }
        ],
        trash_type: [
          {
            required: true,
            message: "Debe seleccionar un tipo de residuo",
            trigger: "change"
          }
        ],
        location: [
          {
            required: true,
            validator: validateLocation, 
            trigger: "change"
          }
        ],
        date: [
          {
            required: true,
            message: "Debe seleccionar una fecha",
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            message: "Debe seleccionar un estado",
            trigger: "change"
          }
        ]
      },
      formLabelWidth: "105px",
      multipleSelection: [],
      currentPage: 4,
      modal: {
        name: "",
        status: "",
        readOnly: false,
        id: ''
      },
      tableQuantity: [
        // {
        //   trash_type: '',
        //   trash_type_t: '',
        //   trash_unit: '',
        //   trash_unit_t: '',
        //   ordered: '',
        //   available: '',
        //   class: '',
        // }
      ],
      minimun: {},
      zoneConfig: {},
      loadingTable: false,
      defaultDate: '',
      selections: {
        list: [],
        count: 0
      },
      dialogAssignDateVisible: false,
      formAssignDate: {
        date: '',
        date_hours: ''
      },
      hasError: false,
      orderSelecteds: []
    };
  },
  props: ['show'],
  async created() {
    // Set the menu index
    let index = 0
    if( this.show === 'pending' ) index = '1-1'
    else if( this.show === 'completed' ) index = '1-2'
    else index = '1-3'

    this.$store.commit("CHANGE_SECTION", { name: "Pedidos", index: index });
    //Load orders
    this.loading = true;
    await this.$store.commit('SET_ORDER_SHOW_TYPE', this.show )
    await this.$store.dispatch("getZones");
    await this.$store.dispatch("getOrders");
    this.$store.dispatch("getConfig");
    this.loading = false;
  },
  methods: {
    hasPermission( permissionReq ) {
      return this.$store.getters.hasPermission('Orders', permissionReq)
    },
    canEdit( field ) {
      if( this.hasPermission('edit') )
        return true

      const edit = {
        client_id: false,
        full_name: false,
        status: false,
        date: false,
        date_hours: false,
        location: false,
        trash_type: false,
        trash_unit: false,
        count: false,
        price: false,
        certificate: false,
        manifest: false,
        notes: false,
        pay: false,
        extraInfo: false,
      }
      if( this.current_user.role == 'commercial' ) {
        edit.manifest = true
        edit.notes = true
        edit.location = true
      } else if( this.current_user.role == 'driver' ) {
        edit.count = true
        edit.notes = true
      }

      // If field is defined check the value, else check if there is any true
      if( field ) {
        return edit[field]
      } else {
        // If there is any true, return true
        for (var prop in edit) {
          if (edit.hasOwnProperty(prop)) {
            if( edit[prop] )
              return true
          }
        }
        return false
      }
    },
    msgSuccess(text) {
      this.$message({
        type: "success",
        message: text
      });
    },
    msgError(text) {
      this.$message({
        type: "error",
        showClose: true,
        duration: 0,
        message: text
      });
    },
    filterStatus(value, row) {
      return row.status === value
    },
    filterCert( value, row) {
      return (row.certificate && value) || (!row.certificate && !value)
    },
    filterMan( value, row) {
      return (row.manifest && value) || (!row.manifest && !value)
    },
    filterPay( value, row) {
      return row.pay === value
    },
    filterUnits(value, row) {
      return row.trash_unit === value
    },
    filterZone(value, row) {
      return row.zone === value
    },
    filterTrashType( value, row ) {
      if( row.trash_type === value )
        return true
      else if( !this.$store.state.orders.options.find(element => element.value == row.trash_type ) && value === 'others' )
        return true
      else
        return false
    },/*
    handleSizeChange(val) {
      console.log(`${val} items per page`);
    },
    handleCurrentChange(val) {
      console.log(`current page: ${val}`);
    },*/
    changeCheck(value) {
      const [orderId, status] = value.split('-')
      const order = this.orderList.find( e => e.id === orderId )

      if( status === 'true' ) {
        this.multipleSelection.push(order)
      } else if ( status === 'false' ) {
        // Remove from selected array
        const index = this.multipleSelection.findIndex( e => e.id === orderId )
        this.multipleSelection.splice( index, 1 )
      }
      this.handleSelectionRow( null, order)
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let unit = null
      const position = this.current_user.role == 'driver' || this.current_user.role == 'commercial' ? 2 : 3
      sums[position] = 0;
      
      data.forEach( e => {
        sums[position] += parseFloat(e.count)

        if( unit === null )
          unit = e.trash_unit_t
        if( unit != e.trash_unit_t )
          unit = ''
      })

      if( unit ) {
        sums[0] = ''
        sums[1] = 'Total';
        sums[position] += ' ' + unit
        return sums;
      }
      return ''
    },
    handleDialogClose() {
      this.$refs["form"].resetFields();
      this.form = { count: 1, price: 0 };
      this.trash_types = []
      this.date = null
      this.modal = {}
      this.minimun = {}
    },
    handleDialogAssignDateClose() {
      this.$refs["formAssignDate"].resetFields();
      cleanObject(this.formAssignDate)
      cleanObject(this.selections)
      cleanObject(this.orderSelecteds)
      this.multipleSelection = []
      this.hasError = false
    },
    handleView(row, column, event) {
      this.modal = { name: "Ver Pedido", status: "view", readOnly: true };

      // Load business info
      if( this.current_user.role === 'commercial' ) {
        const user = this.$store.state.users.userList.find( e => e.id == row.client_id )
        if( user ) {
          row.cuit = user.cuit
          row.business_address = user.business_address + ', ' + user.business_city + ', ' +  user.business_province
        }
      }

      this.form = { ...row };
      this.dialogFormVisible = true;
    },
    async handleCreate(index, row) {
      if( this.hasPermission('edit') ) {
        await this.$store.dispatch("getUsers");
        await this.$store.dispatch("getConfig");
        this.modal = { name: "Nuevo Pedido", status: "add", readOnly: false };
        this.dialogFormVisible = true;
        //this.form.status = 'pending' // Set pending by default
      }
      
    },
    async handleEdit(row) {
      if( this.canEdit() ) {
        await this.$store.dispatch("getUsers");
        await this.$store.dispatch("getConfig");
        this.modal = { name: "Editar Pedido", status: "edit", readOnly: false, id: row.id };

        this.locations.push({
          label: row.location,
          value: row.location_index,
          zone: row.zone,
          zone_id: row.zone_id,
        })

        if( this.current_user.role === 'commercial' ) {
          if( row.cuit ) delete row.cuit
          if( row.business_address ) delete row.business_address
        }

        this.form = { ...row };
        this.date = this.form.date
        
        this.dialogFormVisible = true;
        this.updateQuantityTable('date')
        this.handleCheckZoneMininum('zone')
      }
    },
    handleSelectionChange( val ) {
      this.multipleSelection = val
    },
    handleSelectAll( selection ) {
      if( this.selectionToChange === 'assignDate') {
        // Disable select/deselect all option
        this.$refs.orderListFiltered.clearSelection();
        this.selections.list.forEach(row => {
          this.$refs.orderListFiltered.toggleRowSelection(row);
        });
      }
    }, 
    handleSelectionRow( selection, selRow ) {
      if( this.selectionToChange === 'assignDate') {
        const index = this.selections.list.indexOf(selRow)
        let maxLoad = 0;

        try {
          maxLoad = this.$store.state.config.config[selRow.trash_type].quantity[selRow.trash_unit];
        }
        catch {}

        if( index > -1 ) {
          // If is selected, remove from selected list
          this.selections.count -= selRow.count
          this.selections.list.splice( index, 1 )
        } else {
          // If current trash type is distinct to selected trash type, prevent to select
          if( this.selections.list.length > 0 && this.selections.list[0].trash_type != selRow.trash_type ) {
            
            if( selection ) {
              this.$refs.orderListFiltered.clearSelection();
              this.selections.list.forEach(row => {
                this.$refs.orderListFiltered.toggleRowSelection(row);
              });
            } else {
              this.orderSelecteds[selRow.id] = false
            }
            
            return
          }

          // If is not selected, add to selected list
          this.selections.count += selRow.count
          this.selections.list.push(selRow)
        }

        if( maxLoad > 0 && this.selections.count > maxLoad ) { 
          // If this order count exceed the maximum supported in a truck, remove from selected list
          this.selections.count -= selRow.count
          this.selections.list.splice( index, 1 )
          
          if( selection ) {
            this.$refs.orderListFiltered.clearSelection();
            this.selections.list.forEach(row => {
              this.$refs.orderListFiltered.toggleRowSelection(row);
            });
          } else {
            this.orderSelecteds[selRow.id] = false
          }
          
          this.msgError("El máximo permitido para este tipo de resiudo es de " + maxLoad + " " + selRow.trash_unit_t);
          return
        }
      }
    },
    handleChangeState() {
      if( this.hasPermission('edit') ) {
        if( this.selectionToChange === '') {
          this.msgError("Debe seleccionar un estado de pedido para aplicar");
          return
        }
        
        if( this.multipleSelection.length === 0 ) {
          this.msgError("Debe seleccionar al menos un pedido");
          return
        }
        
        if( this.selectionToChange === 'assignDate') {
          let sums = 0;
          let unit = null;

          this.multipleSelection.forEach( order => {
            sums += parseFloat(order.count)

            if( unit === null )
              unit = order.trash_unit_t
            if( unit != order.trash_unit_t )
              unit = ''
          })
          if( unit )
            this.dialogAssignDateVisible = true;
          
        } else {
          this.$confirm(
            "Está por actualizar uno o más pedidos, ¿Desea continuar?",
            "Actualizar Pedidos",
            {
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          ).then(() => {
            const d = new Date,
            now = [d.getDate(),
                  d.getMonth()+1,
                  d.getFullYear()].join('/')+' '+
                  [d.getHours(),
                  d.getMinutes()].join(':')
                  
            this.multipleSelection.forEach( order => {
              if( order.status != this.selectionToChange ) {
                order.updated_at = now
                order.updated_by = this.current_user.displayName
                order.status = this.selectionToChange
                this.$store.dispatch("updateOrder", order)
              }
            })
          }).catch(() => {})
        }
        
      }
    },
    handleCertificate( row ) {
      if( this.hasPermission('edit') || this.canEdit('certificate') ) {
        this.handleEdit(row)
      }
    },
    handleManifest( row ) {
      if( this.hasPermission('edit') || this.canEdit('manifest') ) {
        this.handleEdit(row)
      }
    },
    handlePay( row ) {
      if( this.hasPermission('edit') || this.canEdit('pay') ) {
        const clientName = row.business ? row.business : row.full_name
        this.$confirm(
          "Desea actualizar el pedido de " + clientName,
          "Actualizar pedido",
          {
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
          .then(() => {
            row.pay = !row.pay
            this.$store.dispatch("updateOrder", row)
            .then(() => {
              this.msgSuccess("El pedido fue actualizado")
            })
            .catch(() => {
              this.msgError("Error actualizando el pedido, probablemente ya no exista en la base de datos. Recargue la página")
            })
          }).catch(() => {})
      }
    },
    async updateQuantityTable(change) {

      if( change == 'date' ) {
        //Check the DB for current date
        this.loadingTable = true
        this.tableQuantity = []
        
        await this.$store.dispatch( 'getOrdersFromDate', this.form.date )
        .then( (result) => {
          result.forEach( order => {
            if( order.id != this.modal.id ) {
              const element = this.tableQuantity.find( e => e.trash_type == order.trash_type && e.trash_unit == order.trash_unit)
              if( element ) {
                element.ordered += order.count
                if( this.$store.state.config.config[element.trash_type] )
                  element.available -= order.count
              } else {
                const res_type = this.$store.state.orders.options.find( e => e.value == order.trash_type )
                const res_unit = res_type ? res_type.unit.find( e => e.value == order.trash_unit ) : null
                const available = this.$store.state.config.config[order.trash_type] ? this.$store.state.config.config[order.trash_type].quantity[order.trash_unit] - order.count : '-'
                this.tableQuantity.push({
                  trash_type: order.trash_type,
                  trash_unit: res_unit ? order.trash_unit : 'drum',
                  trash_type_t: res_type ? res_type.label : order.trash_type,
                  trash_unit_t: res_unit ? res_unit.label : 'Tambor/es',
                  ordered: order.count,
                  available: available,
                  class: ''
                })
              }
            }
          })
        })
        this.loadingTable = false
      } else if( change == 'unit' || change == 'type' ) {
          this.tableQuantity.forEach( e => e.class = '' )
      }
       
      const element = this.tableQuantity.find( e => e.trash_type == this.form.trash_type && e.trash_unit == this.form.trash_unit)
      if( element )
        element.class = element.available < this.form.count ? 'error' : ''
    },
    handleChangeStatus(status) {
      if( this.hasPermission('edit') ) {
        if( status === 'programmed' ) {
          // Find if exist programmed orders in the DB
          this.$store.dispatch('getNextProgrammedOrder')
          .then( (order) => {
            if( order )
              this.defaultDate = new Date(order.date+"T00:00:00")
          })
        }
      }
    },
    handleChangeDate(date) {
      // if( this.date && date != this.date )
      //   this.form.status = 'rescheduled'

      // Get orders to this date and trash type
      this.updateQuantityTable('date')
    },
    handleChangeLocation() {
      // Check the minimun for selected zone
      this.handleCheckZoneMininum('zone')
    },
    handleChangeTrashType(type) {
      this.trash_units = this.trash_types.find(element => element.value == type).unit
      
      //this.form.trash_unit = ''
      if( this.trash_units.length == 1 ) {
        this.form.trash_unit = this.trash_units[0].value
      }

      this.handleChangeCount(this.form.count)

      // Get orders to this date and trash type
      this.updateQuantityTable('type')

      // Check the minimun for selected zone
      this.handleCheckZoneMininum()
    },
    handleCheckZoneMininum( type = '' ) {
      const trash = this.form.trash_type
      const unit = this.form.trash_unit
      const count = this.form.count
      const location_index = this.form.location_index
      
      if( trash && unit && count && location_index != null ) {
        
        const zone_id = this.locations[location_index].zone_id
        if( type == 'zone' ) {
          this.zoneConfig = this.$store.state.zones.zoneList.find( zone => zone.id == zone_id )          
        }
        
        if( this.zoneConfig ) {
          const countMinimun = this.zoneConfig[trash + '_' + unit]
          if( count < countMinimun ) {
            this.minimun = {
              count: countMinimun,
              unit_t: this.units.find( e => e.value == unit ).text
            }
          } else {
            this.minimun = {}
          }
        }

      }
    },
    handleChangeTrashUnit() {
      this.handleChangeCount(this.form.count)

      // Get orders to this date and trash type
      this.updateQuantityTable('unit')

      // Check the minimun for selected zone
      this.handleCheckZoneMininum()
    },
    handleChangeCount(count) {
      const trash_type = this.form.trash_type
      const trash_unit = this.form.trash_unit
      const trash = this.$store.state.config.config[trash_type]
      
      if( trash && trash.price && trash.price[trash_unit] )
        this.form.price = trash.price[trash_unit] * count
      else
        this.form.price = 0

      // Get orders to this date and trash type
      this.updateQuantityTable('count')

      // Check the minimun for selected zone
      this.handleCheckZoneMininum()
    },
    handleChangeClient(clientId) {
      // this.$refs["form"].resetFields();
      const user = this.$store.state.users.userList.find( e => e.id === clientId )
      
      this.locations = []
      for( var i = 0; i < user.locations.length; i++) {
        
        this.locations.push({
          label: user.locations[i].name,
          value: i,
          zone: user.locations[i].zone,
          zone_id: user.locations[i].zone_id
        })
      }

      // If has only one location, set by default
      if( this.locations.length == 1 ) {
        this.form.location_index = 0
      } else {
        this.form.location_index = null
      }

      this.trash_types = []
      user.trash_type.forEach( e => {
        let trash = this.$store.state.orders.options.find(element => element.value == e)

        this.trash_types.push(
          {
            label: trash ? trash.label : e, 
            value: e,
            unit: trash ? trash.unit : [{label:'Tambor/es', value:'drum'}]
          }
        )
      })

      // set by default the first trash type
      this.form.trash_type = this.trash_types[0].value
      this.handleChangeTrashType(this.trash_types[0].value)

      if( this.locations.length == 1 ) {
        // Check the minimun for selected zone
        this.handleCheckZoneMininum('zone')
      }
    },
    getClient(clientId, locationIndex) {

      const user = this.$store.state.users.userList.find( e => e.id == clientId )
      
      const client = {
        full_name: user.full_name,
        business: user.business,
        activity: user.activity,
        id: user.id,
        location: user.locations[locationIndex].address + ', ' + user.locations[locationIndex].city + ', ' + user.locations[locationIndex].province,
        zone: user.locations[locationIndex].zone,
        zone_id: user.locations[locationIndex].zone_id,
        frecuency: user.frecuency,
        location_phone: user.locations[locationIndex].responsable_phone
      }
      return client
    },
    handleAssignDateSaveButton( formName ) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // Valid form
          this.loadingSaveButton = true;
          const d = new Date,
          now = [d.getDate(),
                d.getMonth()+1,
                d.getFullYear()].join('/')+' '+
                [d.getHours(),
                d.getMinutes()].join(':')
          
          this.selections.list.forEach( async order => {
            if( order.status === 'pending' ) {
              order.status = 'programmed'
            } else if( order.status === 'programmed' ) {
              order.status = 'rescheduled'
            }

            order.updated_at = now
            order.updated_by = this.current_user.displayName

            order.date = this.formAssignDate.date
            order.date_hours = this.formAssignDate.date_hours

            await this.$store.dispatch("updateOrder", order)
            .then(() => {})
            .catch(() => {
              this.hasError = true
            });
            
          })

          if( this.hasError ) {
            this.msgError("Hubo errores actualizando algunos pedidos");
          } else {
            this.msgSuccess("Se actualizaron correctamente todos los pedidos");
          }
          
          this.loadingSaveButton = false;
          this.dialogAssignDateVisible = false;
        }
      });
    },
    handleSuccessButton(formName) {
      this.$refs[formName].validate( valid => {
        if (valid) {
          // Valid form
          this.form.status = 'completed'
          this.handleSaveButton(formName);
        }
      })
    },
    handleSaveButton(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // Valid form
          this.loadingSaveButton = true;
          
          const d = new Date,
          now = [d.getDate(),
                d.getMonth()+1,
                d.getFullYear()].join('/')+' '+
                [d.getHours(),
                d.getMinutes()].join(':')

          const client = this.getClient(this.form.client_id, this.form.location_index)

          if (this.modal.status === "add") {
            // Save client profile
            this.form.full_name = client.full_name
            this.form.business = client.business
            this.form.activity = client.activity
            this.form.location = client.location
            this.form.location_phone = client.location_phone
            this.form.zone = client.zone
            this.form.zone_id = client.zone_id

            this.form.created_at = now
            this.form.created_by = this.current_user.displayName
            await this.$store
              .dispatch("addOrder", this.form)
              .then(() => {
                this.msgSuccess("El pedido fue agregado");
              })
              .catch(() => {
                this.msgError("Hubo un error agregando el pedido");
              });
          } else {
            // If change status to without programming, reset date
            this.form.date = this.form.status === 'pending' ? '' : this.form.date

            this.form.updated_at = now
            this.form.updated_by = this.current_user.displayName
            await this.$store.dispatch("updateOrder", this.form)
              .then(() => {
                
                // Add or Update reminder
                if( this.form.date && this.form.status == 'completed' && this.options.find( e => e.value == this.form.trash_type)) {
                  
                  let reminder = {
                    client_id: client.id,
                    client_name: client.full_name,
                    client_business: client.business,
                    trash_type: this.form.trash_type
                  }
                  
                  if( client.frecuency[this.form.trash_type] ) {
                    
                    const date = new Date(this.form.date+"T00:00:00");
                    date.setDate(date.getDate() + Number(client.frecuency[this.form.trash_type]));

                    reminder.date = [
                                      date.getFullYear(),
                                      ('0' + (date.getMonth() + 1)).slice(-2),
                                      ('0' + date.getDate()).slice(-2)
                                    ].join('-');

                    this.$store.dispatch('addReminder', reminder)
                  }
                }

                this.msgSuccess("El pedido fue actualizado");
              })
              .catch(() => {
                this.msgError(
                  "Error actualizando el pedido, probablemente ya no exista en la base de datos. Recargue la página"
                );
              });
          }
          this.loadingSaveButton = false;
          this.dialogFormVisible = false;
        }
      });
    },
    handleDelete(row) {
      this.$confirm(
        "Estás por borrar completamente el pedido de " + row.full_name,
        "Borrar",
        {
          confirmButtonText: "Borrar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      ).then(() => {
        this.$store
          .dispatch("deleteOrder", row)
          .then(() => {
            this.msgSuccess("El pedido fue eliminado");
          })
          .catch(() => {
            this.msgError("Error eliminando el pedido");
          });
      }).catch(() => {})
    },
    handleDownload() {
      this.loadingExportButton = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          'Estado', 'Fecha', 'Hora', 'Nº Certificado', 'Nº Manifiesto', 'Actividad', 'Apellido y Nombre', 'Razón Social', 'Dirección',
          'Teléfono del responsable', 'Zona', 'Tipo de residuo', 'Cantidad', 'Unidad', 'Precio ($)', 'L', 'Notas'
          ];
        const filterVal = [
          'status_label', 'date_text', 'date_hours', 'certificate', 'manifest', 'activity_t', 'full_name', 'business', 'location',
          'location_phone', 'zone', 'trash_type_t', 'count', 'trash_unit_t', 'price', 'pay', 'notes'
          ]; 
        const data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "pedidos"
        });
        this.loadingExportButton = false;
      });
    },
    formatJson(filterVal) {
      // Export only visible elements, if use filter, only export filtered elements
      return this.$refs.orderListFiltered.tableData.map(v =>
        filterVal.map(j => {
          if (j === "pay") {
            return v.pay ? "Si" : "No";
          } else {
            return v[j];
          }
        })
      );
    }
  },
  computed: {
    status() {
      if( this.modal.status === 'add' ) {
        return this.$store.state.orders.status.filter( 
          item => item.value == 'pending' || item.value == 'programmed' 
        )
      } else {
        return this.$store.state.orders.status
      }
    },
    searchInLowerCase() {
      return this.search.toLowerCase().trim();
    },
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    orderList() {
      const orderList = this.$store.state.orders.orderList

      // Order by date
      orderList.sort(function(a, b) {
        var nameA = a.date;
        var nameB = b.date;
        if (nameA > nameB) {
          return -1;
        }
        if (nameA < nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      return orderList;
    },
    zones() {
      const zoneList = [];
      this.$store.state.zones.zoneList.forEach(zone => {
        if (!zoneList.includes(zone.name)) {
          // Add text and value for filter in table, and disable and label for select
          zoneList.push({
            text: zone.name,
            value: zone.name
          });
        }
      });

      // Order by name
      zoneList.sort(function(a, b) {
        var nameA = a.text.toUpperCase(); // ignore upper and lowercase
        var nameB = b.text.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      return zoneList;
    },
    units() {
      return [
        {
          text: 'm3',
          value: 'm3'
        }, {
          text: 'Tambor/es',
          value: 'drum'
        }
      ]
    },
    clients() {
      const userList = [];
      this.$store.state.users.userList.forEach(user => {
        let label = ''
        if( user.business ) {
          label = user.full_name + ' (' + user.business + ')'
        } else {
          label = user.full_name
        }
        userList.push({
          label: label,
          value: user.id,
          disabled: !user.is_active
        });
      });

      // Order by name
      userList.sort(function(a, b) {
        var nameA = a.label.toUpperCase(); // ignore upper and lowercase
        var nameB = b.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });

      return userList;
    },
    current_user() {
      return this.$store.state.current_user
    },
    isAdmin() {
      return this.current_user.role === 'superUser' || this.current_user.role === 'admin' ? true : false
    },
    options() {
      let options = []
      this.$store.state.orders.options.forEach( e => {
        options.push({text: e.label, value: e.value})
      })
      options.push({text: 'Otros', value: 'others'})

      // Order by name
      options.sort(function(a, b) {
        var nameA = a.text.toUpperCase(); // ignore upper and lowercase
        var nameB = b.text.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return options
    },
  }
};
</script>

<style>
.count {
  margin-bottom: 5px;
}
.count .el-form-item__content {
    display: flex;
}
@media screen and (max-width: 700px) {
  .el-dialog {
    width: 90% !important;
  }

  .el-main {
    padding: 20px !important;
  }
}
.el-select {
  width: 100%;
}
.locations .el-form-item {
  margin-bottom: 25px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}
.el-form-item__content {
    line-height: 39px;
}
.extra-info {
    font-size: 12px;
    text-align: left;
    line-height: 23px;
    color: gray;
    margin-left: 50px;
}
.el-checkbox {
    margin-left: 10px;
}
.el-pagination {
    color: #717171;
    margin-top: 15px;
    float: left;
}
.el-pager li {
    background: transparent;
}
.el-pagination button {
  background: transparent !important;
}
.expired {
  font-weight: 500;
  color: #f57272;
}
.trash-quantity {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.trash-quantity thead {
  font-weight: bold;    
  background: #efefef;
}

.trash-quantity thead th {
  width: 25%;
  text-align: center;
}

.trash-quantity tr td {
  text-align: center;
  height: 25px;
}

.error {
  font-weight: bold;
  color: white;
  background: #f57272;
}

.el-date-table td.default span {
    color: white;
    font-weight: 700;
    background: #ffa340;
    border-radius: 50%;
}
.red span {
  color: white;
  font-weight: 700;
  background: #ffa340;
  border-radius: 50%;
}
.zoneMsg {
  padding-bottom: 20px;
  text-align: left;
  margin-left: 120px;
  color: #F56C6C;
  font-size: 12px;
}

.icon-red {
  color: #F56C6C;
}
.icon-green {
  color: #3ed43e;
}
.el-card {
    margin: 5px;
}

.card-body {
    font-size: 13px;
}
.el-card__body {
    padding: 6px;
}
.card-order .card-header {
  padding-top: 10px;
  text-align: left;
  padding-bottom: 5px;
}
.card-body div {
    margin-top: 10px;
    margin-bottom: 10px;
}
.card-body .el-tag {
  margin-right: 5px;
}

.card-body .trash {
  font-size: 14px;
}

.el-card__header {
    padding: 6px 6px;
}
</style>